import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { catchError, retry, map, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
//import { UsersProperties, LoginUserProperties, LoginUserRights, UserStatisticsProps, UserRoles, GetAllProvinceDistrictTehsilCityTown, userBackCompanyCustomerCode } from '../Models/UsersProperties';
import { UsersProperties, LoginUserProperties, LoginUserRights, UserStatisticsProps, UserRoles, GetAllProvinceDistrictTehsilCityTown, AssignedAirlinesForTicketIssueBaseData, userBackCompanyCustomerCode } from '../Models/UsersProperties';
import { ActiveAgencies, Agency_Branches, B2BActiveBranches } from '../Models/ActiveClasses';
import { UserListProperties } from '../Models/UserListProperties';
import { Agencies_BranchesProperties } from '../Models/AgencyMasterProperties';
import { AgencyRightsProperties } from '../Models/AgencyRightsProperties';
import { NavMenuItems } from '../Models/NavMenuItems';

@Injectable({
  providedIn: 'root'
})
export class UsersService {
  baseUrl = environment.baseUrl;
  backSystemUrl = environment.backSystemBaseUrl;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  }
  constructor(private http: HttpClient) { }


  LoginUser(loginobj: LoginUserProperties): Observable<number> {
    return this.http.post<number>(this.baseUrl + '/Users/LoginUser', loginobj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  CreateUser(userObj: UsersProperties): Observable<number> {
    return this.http.post<number>(this.baseUrl + '/Users/CreateUser', userObj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  UpdateUser(userObj: UsersProperties): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/Users/UpdateUser', userObj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  UpdateUserDistricts(payload: { userId: number, districtIds: number[] }): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/Users/UpdateUsersDistrictsBYAreaByUserId', payload, this.httpOptions)
      .pipe(
        map((data: any) => {
          return data;   // assuming API returns true/false
        }),
        catchError(error => {
          return throwError(error);
        })
      );
  }

  UpdateUserStatus(userId, status, modifyUser): Observable<boolean> {
    return this.http.get<boolean>(this.baseUrl + '/Users/UpdateUserStatus/' + userId + "/" + status + "/" + modifyUser)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }

  ResetUser(userId, modifyUser): Observable<boolean> {
    return this.http.get<boolean>(this.baseUrl + '/Users/ResetUser/' + userId +  "/" + modifyUser)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  GetAllUser(param, userId): Observable<UsersProperties[]> {
    return this.http.get<UsersProperties[]>(this.baseUrl + '/Users/GetAllUsers/' + param + "/" + userId)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  GetUserByID(userId): Observable<UsersProperties> {
    return this.http.get<UsersProperties>(this.baseUrl + '/Users/GetUserByID/' + userId)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  GetChildAgencies(param): Observable<ActiveAgencies[]> {
    return this.http.get<ActiveAgencies[]>(this.baseUrl + '/AgencyMaster/GetChildAgencies/' + param)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  GetParentChildBranches(param): Observable<B2BActiveBranches[]> {
    return this.http.get<B2BActiveBranches[]>(this.baseUrl + '/BranchInformation/GetParentChildBranches/' + param)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }

  GetAllUsers(groupName): Observable<UserListProperties[]> {
    return this.http.get<UserListProperties[]>(this.backSystemUrl + '/Users/getAllUsers/' + groupName).pipe(map((data: any) => {
      return data;
    }), catchError(error => { return throwError(error); }))
  }

  GetLoginUserRights(userId): Observable<LoginUserRights> {
    return this.http.get<LoginUserRights>(this.baseUrl + '/Users/GetLoginUserRights/' + userId)
      .pipe(map((data: any) => {
        // //console.log(data);
        return data;
      }), catchError(error => {  return throwError(error); }))
  }

  GetAgency_BranchByParent(param): Observable<Agency_Branches[]> {
    return this.http.get<Agency_Branches[]>(this.baseUrl + '/AgencyMaster/GetAgency_BranchByParent/' + param)
      .pipe(map((data: any) => {
        // //console.log(data);
        return data;
      }), catchError(error => { //console.log(error);
        return throwError(error);
      }))
  }

  GetAllAgencies(param, userId): Observable<Agencies_BranchesProperties[]> {
    return this.http.get<Agencies_BranchesProperties[]>(this.baseUrl + '/AgencyMaster/GetAllAgencies/' + param + "/" + userId)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }

  GetparentAgencyRights(param,user): Observable<AgencyRightsProperties> {
    return this.http.get<AgencyRightsProperties>(this.baseUrl + '/AgencyMaster/GetparentAgencyRights/' + param + '/' + user)
      .pipe(map((data: any) => {
        // //console.log(data);
        return data;
      }), catchError(error => { //console.log(error);
        return throwError(error);
      }))
  }
  

  CheckUsersLimit(param, isAgency): Observable<number> {
    return this.http.get<number>(this.baseUrl + '/Users/CheckUsersLimit/' + param + "/" + isAgency)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }

  GetUsersNavMenu(agencyId, userId): Observable<NavMenuItems> {
    return this.http.get<NavMenuItems>(this.baseUrl + '/Users/GetUsersNavMenu/' + agencyId + "/" + userId, this.httpOptions)
      .pipe(map((data: any) => {
        // ////console.log(data)
        return data;
      }), catchError(error => {
        //console.log(error);
        return null
      }))
  }

  EmailExist(email, userId): Observable<boolean> {
    return this.http.get<boolean>(this.baseUrl + '/BranchInformation/CheckEmailValidation?userEmail=' + email + '&userId=' + userId)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }

  checkUsersUpdateRightAgainstAgencyAndUserId(agencyId, userId): Observable<boolean> {
    return this.http.get<boolean>(this.baseUrl + '/Users/checkUsersUpdateRightAgainstAgencyAndUserId/' + agencyId + "/" + userId)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => {
        //console.log(error);
        return throwError(error);
      }))
  }
  checkProfileRightAgainstAgencyAndUserId(agencyId, userId): Observable<boolean> {
    return this.http.get<boolean>(this.baseUrl + '/Users/checkProfileRightAgainstAgencyAndUserId/' + agencyId + "/" + userId)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => {
        //console.log(error);
        return throwError(error);
      }))
  }
  checkAccountRightAgainstAgencyAndUserId(agencyId, userId): Observable<boolean> {
    return this.http.get<boolean>(this.baseUrl + '/Users/CheckAccountRightAgainstAgencyAndUserId/' + agencyId + "/" + userId)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => {
        //console.log(error);
        return throwError(error);
      }))
  }
  checkCurrencyRightAgainstAgencyAndUserId(agencyId, userId): Observable<boolean> {
    return this.http.get<boolean>(this.baseUrl + '/Users/CheckCurrencyRightAgainstAgencyAndUserId/' + agencyId + "/" + userId)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => {
        //console.log(error);
        return throwError(error);
      }))
  }

  GetAllUsersFromParentBranchChildAgenciesForStatus(agencyId): Observable<UserStatisticsProps> {
    return this.http.get<UserStatisticsProps>(this.baseUrl + '/Users/GetAllUsersFromParentBranchChildAgenciesForStatus/' + agencyId)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  updatePassword(userObj: LoginUserProperties): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/CmsLogin/UpdatePasswordofCurrentUser', userObj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  
  GetAllUserRoles(userId: number): Observable<UserRoles[]> {
    return this.http.get<UserRoles[]>(this.baseUrl + '/Users/GetAllUserRoles/'+userId)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  GetAllProvinceDistrictTehsilCityTown(): Observable<GetAllProvinceDistrictTehsilCityTown> {
    return this.http.get<GetAllProvinceDistrictTehsilCityTown>(this.baseUrl + '/Users/GetAllProvinceDistrictTehsilCityTown')
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  GetAllUserBackCompanyCustomerCode(): Observable<userBackCompanyCustomerCode[]> {
    return this.http.get<userBackCompanyCustomerCode[]>(this.baseUrl + '/Users/GetAllUserBackCompanyCustomerCode')
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }

  GetAssignedAndAllAirlinesForTicketIssueByID(agencyId, userId): Observable<AssignedAirlinesForTicketIssueBaseData> {
    return this.http.get<AssignedAirlinesForTicketIssueBaseData>(this.baseUrl + '/Users/GetAssignedAndAllAirlinesForTicketIssueByID/' + agencyId + "/" + userId)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { //console.log(error);
        return throwError(error);
      }))
  }
}
